export default "__VITE_ASSET__4BheN1P3__"